export default "__VITE_ASSET__b153a713__"